import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/rate-star.png'


const _withScopeId = n => (_pushScopeId("data-v-145e517c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submit-tenant-report-container mb-10" }
const _hoisted_2 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid new-stepper",
  id: "kt_create_account_stepper"
}
const _hoisted_3 = { class: "d-flex justify-content-center bg-body rounded justify-content-xl-start flex-row-auto stepper-container" }
const _hoisted_4 = {
  class: "px-6 pb-20",
  style: {"width":"100%"}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex stepper-header\" style=\"margin-top:41px;margin-bottom:69px;\" data-v-145e517c><img src=\"" + _imports_0 + "\" data-v-145e517c><div style=\"margin-left:14px;\" data-v-145e517c><h1 class=\"title\" data-v-145e517c>Log Tenant Reference</h1><span class=\"text\" data-v-145e517c>Fill in the form below to submit a tenant reference</span></div></div>", 1)
const _hoisted_6 = { class: "d-flex flex-row-fluid bg-body rounded" }
const _hoisted_7 = {
  style: {"padding-top":"41px"},
  class: "pb-20 w-100 w-xl-700px px-9",
  novalidate: "novalidate",
  id: "kt_create_account_form"
}
const _hoisted_8 = { class: "d-flex flex-stack pt-10" }
const _hoisted_9 = { class: "mr-2" }
const _hoisted_10 = ["data-kt-indicator"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<span class=\"indicator-label\" data-v-145e517c>Submit <span class=\"svg-icon svg-icon-3 ms-2 me-0\" data-v-145e517c><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-145e517c><rect opacity=\"0.5\" x=\"18\" y=\"13\" width=\"13\" height=\"2\" rx=\"1\" transform=\"rotate(-180 18 13)\" fill=\"black\" data-v-145e517c></rect><path d=\"M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z\" fill=\"black\" data-v-145e517c></path></svg></span></span><span class=\"indicator-progress\" data-v-145e517c>Please wait... <span class=\"spinner-border spinner-border-sm align-middle ms-2\" data-v-145e517c></span></span>", 2)
const _hoisted_13 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_Stepper = _resolveComponent("Stepper")!
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!
  const _component_Step4 = _resolveComponent("Step4")!
  const _component_Suggestion = _resolveComponent("Suggestion")!
  const _component_Submitted = _resolveComponent("Submitted")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Navigator, { text: "Back to dashboard" }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_Stepper, { "current-step": _ctx.currentStep }, null, 8, ["current-step"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("form", _hoisted_7, [
                  _createVNode(_component_Step1, {
                    ref: "step1",
                    onFindExistingTenant: _ctx.debounceFindExistingTenant,
                    onSubmit: _ctx.validateStep,
                    "is-current": _ctx.currentStep == 1
                  }, null, 8, ["onFindExistingTenant", "onSubmit", "is-current"]),
                  _createVNode(_component_Step2, {
                    ref: "step2",
                    onSubmit: _ctx.validateStep,
                    "is-current": _ctx.currentStep == 2
                  }, null, 8, ["onSubmit", "is-current"]),
                  _createVNode(_component_Step3, {
                    ref: "step3",
                    onSubmit: _ctx.validateStep,
                    "is-current": _ctx.currentStep == 3,
                    questions: _ctx.reviewQuestions
                  }, null, 8, ["onSubmit", "is-current", "questions"]),
                  _createVNode(_component_Step4, {
                    onUploadLedgerFile: _ctx.handleLedgerFile,
                    ref: "step4",
                    "is-current": _ctx.currentStep == 4
                  }, null, 8, ["onUploadLedgerFile", "is-current"]),
                  (_ctx.showingSuggestion)
                    ? (_openBlock(), _createBlock(_component_Suggestion, {
                        key: 0,
                        tenant: _ctx.existingTenant,
                        onUse: _ctx.useExistingTenant
                      }, null, 8, ["tenant", "onUse"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.currentStep > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goPreviousStep())),
                            type: "button",
                            class: "btn btn-lg btn-new-design-secondary me-3"
                          }, " Back "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.currentStep === _ctx.maxStep)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                            type: "button",
                            class: "btn btn-lg btn-new-design-primary me-3",
                            "data-kt-indicator": _ctx.loading ? 'on' : null
                          }, _hoisted_13, 8, _hoisted_10))
                        : _createCommentVNode("", true),
                      (_ctx.currentStep < _ctx.maxStep)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goNextStep && _ctx.goNextStep(...args))),
                            class: "btn btn-lg btn-new-design-primary",
                            "data-kt-stepper-action": "next"
                          }, " Next "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isSubmitted)
      ? (_openBlock(), _createBlock(_component_Submitted, {
          key: 1,
          refNo: _ctx.referenceNo,
          link: _ctx.referenceLink,
          onNew: _ctx.handleCreateNewTenantReview,
          class: "mb-10"
        }, null, 8, ["refNo", "link", "onNew"]))
      : _createCommentVNode("", true)
  ]))
}